/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type WorkspaceMemberRole = typeof WorkspaceMemberRole[keyof typeof WorkspaceMemberRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceMemberRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
} as const;
